module.exports = __webpack_public_path__ + "img/button_viewer.ace6bd31.svg";